export default __webpack_public_path__ + "df76d259a8965439ef6e3df74126316d.svg";